"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = exports.ModalDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_modal_1 = require("../../hooks/use-modal");
var icon_button_1 = require("./icon-button");
var use_icons_1 = require("../../hooks/use-icons");
var cell_label_1 = require("./cell-label");
exports.ModalDefaultProps = {
  color: "primaryDarker",
  opacity: 0.90,
  zIndex: 150,
  showCloseButton: true
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    left: 0;\n    top: 0;\n    position: fixed;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ", "\n\n    ", "\n  "], ["\n    left: 0;\n    top: 0;\n    position: fixed;\n    height: 100%;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    ", "\n\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      background-color: ", "", ";\n      z-index: ", ";\n    "], ["\n      background-color: ", "", ";\n      z-index: ", ";\n    "])), theme_1.theme.COLOR(props._color), Math.round(props._opacity * 255).toString(16), props._zIndex);
  }, function (props) {
    return props._align === 'flex-start' && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      align-items: flex-start;\n      padding-top: 100px; \n    "], ["\n      align-items: flex-start;\n      padding-top: 100px; \n    "])));
  })
});
var CloseButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    right: ", ";\n    top: ", ";\n  "], ["\n    position: absolute;\n    right: ", ";\n    top: ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4)),
  desktop: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    right: ", ";\n    top: ", ";\n  "], ["\n    right: ", ";\n    top: ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(3))
});
var ControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    position: absolute;\n    right: 60px;\n    top: ", ";\n  "], ["\n    position: absolute;\n    right: 60px;\n    top: ", ";\n  "])), theme_1.theme.UNIT(4, 1))
});
var LabelAndTitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    font-family: ", ";\n    position: absolute;\n    left: 16px;\n    top: ", ";\n  "], ["\n    font-family: ", ";\n    position: absolute;\n    left: 16px;\n    top: ", ";\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.UNIT(4, 1))
});
var TitleStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    font-size: ", ";\n    font-weight: 500;\n    color: ", ";\n    \n  "], ["\n    font-size: ", ";\n    font-weight: 500;\n    color: ", ";\n    \n  "])), theme_1.theme.FONT_SIZE(18), theme_1.theme.COLOR('light'))
});
var LabelStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    color: ", ";\n  "], ["\n    color: ", ";\n  "])), theme_1.theme.COLOR('light'))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  CloseButton: (0, styled_components_1.default)(icon_button_1.IconButton)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), CloseButtonStyles),
  Controls: styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ControlsStyles),
  LabelAndTitle: styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LabelAndTitleStyles),
  Label: (0, styled_components_1.default)(cell_label_1.CellLabel)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Title: styled_components_1.default.div(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles)
};
var Modal = function (props) {
  var className = props.className,
    color = props.color,
    opacity = props.opacity,
    zIndex = props.zIndex,
    children = props.children,
    showCloseButton = props.showCloseButton;
  var modal = (0, use_modal_1.useModal)();
  var Icons = (0, use_icons_1.useIcons)();
  var ref = (0, react_1.useRef)();
  var options = modal.options;
  var onClick = props.onClick || options.hideOnOverlayClick && function (event) {
    if (ref && ref.current && event.target === ref.current) {
      modal.hide();
    }
  };
  var align = options === null || options === void 0 ? void 0 : options.align;
  return react_1.default.createElement(My.Container, {
    ref: ref,
    _align: align,
    onClick: onClick,
    _color: color,
    _opacity: options.opacity || opacity,
    _zIndex: zIndex,
    className: className
  }, react_1.default.createElement(My.LabelAndTitle, null, options.label && react_1.default.createElement(My.Label, null, options.label), options.title && react_1.default.createElement(My.Title, null, options.title)), react_1.default.createElement(My.Controls, null, options.controls), showCloseButton && react_1.default.createElement(My.CloseButton, {
    icon: react_1.default.createElement(Icons.CrossCircle, null),
    color: "light",
    hoverColor: "primaryLighter",
    iconSize: 32,
    title: "Close",
    onClick: function () {
      return modal.hide();
    }
  }), children);
};
exports.Modal = Modal;
exports.Modal.defaultProps = exports.ModalDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15;